
const initialState = {
  users: [],
  //isFetching: false,
  //error: undefined
};

export function fetchUsers(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_USERS.SUCCESS':
      return {
        ...state,
        users:  action.users,
      }
    default:
      return state
  }
}




// WEBPACK FOOTER //
// ./src/reducers/users.js